import axios from "axios";
import * as actions from "../constants/cartConstants";

// addToCart now accepts size
export const addToCart = (id, qty, size) => async (dispatch, getState) => {
  const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/products/${id}`);

  // Find the correct size entry
  const sizeObj = data.product.sizes?.find(sz => sz.size === size);

  dispatch({
    type: actions.CART_ADD_ITEM,
    payload: {
      product: data.product._id,
      name: data.product.name,
      image: data.product.image,
      price: data.product.price,
      category: data.product.category, // ADD THIS LINE!
      size, // store selected size
      countInStock: sizeObj ? sizeObj.quantity : 0, // specific stock for size
      qty,
    },
  });

  localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
};

// Remove by id and size
export const removeFromCart = (id, size) => async (dispatch, getState) => {
  dispatch({ type: actions.CART_REMOVE_ITEM, payload: { id, size } });

  localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
};

export const saveShippingAddress = (data) => (dispatch) => {
  dispatch({ type: actions.CART_SAVE_SHIPPING_ADDRESS, payload: data });
  localStorage.setItem("shippingAddress", JSON.stringify(data));
};

export const savePaymentMethod = (data) => (dispatch) => {
  dispatch({ type: actions.CART_SAVE_PAYMENT_METHOD, payload: data });
  localStorage.setItem("paymentMethod", JSON.stringify(data));
};

// Set direct purchase product info
export const setDirectPurchase = (product, qty, size) => (dispatch) => {
  dispatch({
    type: actions.DIRECT_PURCHASE_SET,
    payload: { product, qty, size },
  });
};

// Clear direct purchase info (after order placed or cancel)
export const clearDirectPurchase = () => (dispatch) => {
  dispatch({ type: actions.DIRECT_PURCHASE_CLEAR });
};

